import { Controller } from "@hotwired/stimulus";

/*
 * Created for /admin/reporting_snapshots/new
 *
 * The goal is to sync the "Available Roles" select2 tags
 * to any ad-hoc child "role" fields. Any roles added
 * in the parent team's "Available Roles" will immediately be synced
 * to the child role inputs.
 *
 */
export default class extends Controller {
  static targets = ["roleSelect", "availableRoles", "addMemberButton"];

  connect() {
    this.syncRoles(); // Sync on page load

    // Manually bind Select2 event for detecting newly added roles
    $(this.availableRolesTarget).on("select2:close", () => {
      this.syncRoles();
    });

    // Watch for new nested fields being added
    if (this.hasAddMemberButtonTarget) {
      this.addMemberButtonTarget.addEventListener("click", () => {
        setTimeout(() => this.syncRoles(), 0); // Delay to wait for new field insertion
      });
    }
  }

  disconnect() {
    $(this.availableRolesTarget).off("select2:close");
  }

  syncRoles() {
    // Get selected available roles. We intentionally use a querySelectorAll instead
    // of checking for `selected` properties to ensure we get an accurate selection.
    // There is some horrible race condition between Turbo+Stimulus+Select2 that can result
    // in this failing to grab selectedRoles correctly when relying strictly on 
    // the JS property.
    const availableRoles = Array.from(
      this.availableRolesTarget.querySelectorAll("option")
    ).map(option => option.value)
     .filter(role => role.trim() !== "");

    const selectedRoles = Array.from(
      this.availableRolesTarget.querySelectorAll("option[selected]")
    ).map(option => option.value)
     .filter(role => role.trim() !== "");

    // Update all team member role dropdowns
    this.roleSelectTargets.forEach(select => {
      const currentValue = select.value || select.querySelector("option[selected]")?.value || "";

      // If the current value is no longer in the available roles, clear it
      if (currentValue && !selectedRoles.includes(currentValue)) {
        select.value = "";
      }

      // Clear dropdown, add default and append roles from parent
      select.innerHTML = "";
      select.appendChild(new Option("Select Role", "", true));

      availableRoles.forEach(role => {
        const option = new Option(role, role);
        if(role == currentValue) {
          option.selected = true;
          option.setAttribute('selected', 'selected');
        }
        select.appendChild(option);
      });
    });
  }
}

